module.exports = __webpack_public_path__ + "static/media/pablo.0ac7adfd.jpg";